export default {
    namespaced: true,
    state: () => ({
        pageInfo: {
            // 選択されたCheckButtonId
            id: 0,
            viewType:"",
            // menuId => 1:day1, 2:ImCheck, 4:day2
            menuId:"",
            // 何番目に配置された編集ボタンか
            buttonId: "",
            // ボタン名
            buttonName: "",
            // ボタンNO
            buttonNo: ""
        },
        dailyCheckSetting: {
            id: 0,
            no: 0,
        }
    }),
    getters: {
        pageInfo (state) {
            return state.pageInfo
        },
        id (state) {
            return state.pageInfo.id
        },
        viewType (state) {
            return state.pageInfo.viewType
        },
        menuId (state) {
            return state.pageInfo.menuId
        },
        buttonId (state) {
            return state.pageInfo.buttonId
        },
        buttonName (state) {
            return state.pageInfo.buttonName
        },
        dailyCheckPageId (state) {
            return state.dailyCheckSetting.id
        },
        dailyCheckPageNo (state) {
            return state.dailyCheckSetting.no
        },
        buttonNo (state) {
            return state.pageInfo.buttonNo
        },
    },
    mutations: {
        setPageInfo(state, pageInfo) {
            state.pageInfo = pageInfo
        },
        setDailyCheckSetting(state, dailyCheckSetting) {
            state.dailyCheckSetting = dailyCheckSetting
        },
        clearPageInfo(state) {
            state.pageInfo = {}
            state.dailyCheckSetting = {}
        }
    },
    actions: {
        setPageInfo({ commit }, pageInfo) {
            commit('setPageInfo', pageInfo)
        },
        setDailyCheckSetting({ commit }, dailyCheckSetting) {
            commit('setDailyCheckSetting', dailyCheckSetting)
        },
        clearPageInfo({ commit }) {
            commit('clearPageInfo')
        }
    },
}
